import { IconActivity, IconCheck } from '@tabler/icons-react';

const placeholderItems = [
  { label: 'Onboarding completed', time: 'Just now', icon: IconCheck },
  { label: 'Profile information updated', time: 'Recently', icon: IconActivity },
];

export function RecentActivityCard() {
  return (
    <div className="card p-5 h-full">
      <div className="flex items-center gap-2 mb-4">
        <IconActivity size={18} className="text-cyan-400" stroke={1.5} />
        <h3 className="text-sm font-semibold text-gray-100">Recent Activity</h3>
      </div>

      <div className="space-y-3">
        {placeholderItems.map((item, i) => {
          const ItemIcon = item.icon;
          return (
            <div key={i} className="flex items-center gap-3">
              <div className="w-7 h-7 rounded-full bg-cyan-900/30 border border-cyan-500/20 flex items-center justify-center flex-shrink-0">
                <ItemIcon size={14} className="text-cyan-400" />
              </div>
              <div className="min-w-0 flex-1">
                <p className="text-xs text-gray-300 truncate">{item.label}</p>
                <p className="text-[10px] text-gray-600">{item.time}</p>
              </div>
            </div>
          );
        })}
      </div>

      <p className="text-[10px] text-gray-600 mt-4">
        Activity feed will show lab results, document uploads, and more in a future update.
      </p>
    </div>
  );
}
